import loadingTout from '../../../static/ui/loading.json'

export const casinoStoreKey = 'casinoStore'

export const casinoStoreKeys = {
  casinoActiveGame: 'casinoActiveGame',
  casinoActiveNotificationId: 'casinoActiveNotificationId',
  casinoBypassMaintenanceParameter: 'casinoBypassMaintenanceParameter',
  casinoChatBotOpen: 'casinoChatBotOpen',
  casinoDynamicOverlays: 'casinoDynamicOverlays',
  casinoEffectiveAreaPhone: 'casinoEffectiveAreaPhone',
  casinoFeaturedDisplay: 'casinoFeaturedDisplay',
  casinoFlashPrizeGames: 'casinoFlashPrizeGames',
  casinoFlashPrizes: 'casinoFlashPrizes',
  casinoCoinsToFiatRate: 'casinoCoinsToFiatRate',
  casinoGameCabinetKey: 'casinoGameCabinetKey',
  casinoGameCabinetStaticUi: 'casinoGameCabinetStaticUi',
  casinoGameCounts: 'casinoGameCounts',
  casinoHoldNotifications: 'casinoHoldNotifications',
  casinoInitHelpWidget: 'casinoInitHelpWidget',
  casinoIsBoostOverlayShown: 'casinoIsBoostOverlayShown',
  casinoIsPlaythroughOverlayShown: 'casinoIsPlaythroughOverlayShown',
  casinoIsDesktop: 'casinoIsDesktop',
  casinoIsEffectiveAreaPhone: 'casinoIsEffectiveAreaPhone',
  casinoIsNarrowPhone: 'casinoIsNarrowPhone',
  casinoIsPhone: 'casinoIsPhone',
  casinoIsPurchase: 'casinoIsPurchase',
  casinoLogMxParam: 'casinoLogMxParam',
  casinoLogMxPrefixOverride: 'casinoLogMxPrefixOverride',
  casinoPromoInfo: 'casinoPromoInfo',
  casinoReconcileGameBalanceAtEndOfRound: 'casinoReconcileGameBalanceAtEndOfRound',
  casinoReloadGameBalance: 'casinoReloadGameBalance',
  casinoSellSheet: 'casinoSellSheet',
  casinoSweepsRealityCheckInfo: 'casinoSweepsRealityCheckInfo',
  casinoSweepstakesOpenUsingDeepLink: 'casinoSweepstakesOpenUsingDeepLink',
  casinoSweepstakesOrigin: 'casinoSweepstakesOrigin',
  casinoSweepstakesOriginUrl: 'casinoSweepstakesOriginUrl',
  casinoGameRoundPending: 'casinoGameRoundPending',
  casinoDisabledElements: 'casinoDisabledElements',
  casinoUpdateRealityCheckOnAllTabs: 'casinoUpdateRealityCheckOnAllTabs',
  casinoLobby: 'casinoLobby',
  casinoSweepstakesOpen: 'casinoSweepstakesOpen'
}

/**
 * update localStorageVersion in storeConstants.js every time a new property is added or removed from the zustand store;
 * for more see SWEEP-8185
 */
export const casinoStoreInitialValues = {
  [casinoStoreKeys.casinoActiveNotificationId]: null,
  [casinoStoreKeys.casinoLobby]: {
    id: 0,
    banners: [],
    categories: [],
    touts: []
  },
  [casinoStoreKeys.casinoGameCabinetStaticUi]: false,
  [casinoStoreKeys.casinoGameCabinetKey]: '',
  [casinoStoreKeys.casinoReconcileGameBalanceAtEndOfRound]: false,
  [casinoStoreKeys.casinoReloadGameBalance]: false,
  [casinoStoreKeys.casinoIsDesktop]: true,
  [casinoStoreKeys.casinoIsPhone]: false,
  [casinoStoreKeys.casinoIsNarrowPhone]: false,
  [casinoStoreKeys.casinoIsEffectiveAreaPhone]: false,
  [casinoStoreKeys.casinoFeaturedDisplay]: {},
  [casinoStoreKeys.casinoGameCounts]: {},
  [casinoStoreKeys.casinoSweepsRealityCheckInfo]: {},
  [casinoStoreKeys.casinoUpdateRealityCheckOnAllTabs]: false,
  [casinoStoreKeys.casinoSellSheet]: loadingTout,
  [casinoStoreKeys.casinoPromoInfo]: loadingTout,
  [casinoStoreKeys.casinoIsBoostOverlayShown]: false,
  [casinoStoreKeys.casinoIsPlaythroughOverlayShown]: false,
  [casinoStoreKeys.casinoDynamicOverlays]: [],
  [casinoStoreKeys.casinoGameRoundPending]: false,
  [casinoStoreKeys.casinoDisabledElements]: null,
  [casinoStoreKeys.casinoFlashPrizes]: [],
  [casinoStoreKeys.casinoFlashPrizeGames]: {},
  [casinoStoreKeys.casinoIsPurchase]: false,
  [casinoStoreKeys.casinoHoldNotifications]: false,
  [casinoStoreKeys.casinoLogMxParam]: '',
  [casinoStoreKeys.casinoLogMxPrefixOverride]: '',
  [casinoStoreKeys.casinoBypassMaintenanceParameter]: '',
  [casinoStoreKeys.casinoChatBotOpen]: false,
  [casinoStoreKeys.casinoInitHelpWidget]: false,
  [casinoStoreKeys.casinoSweepstakesOrigin]: {},
  [casinoStoreKeys.casinoSweepstakesOriginUrl]: '',
  [casinoStoreKeys.casinoSweepstakesOpenUsingDeepLink]: false,
  [casinoStoreKeys.casinoSweepstakesOpen]: false,
  [casinoStoreKeys.casinoActiveGame]: null,
  [casinoStoreKeys.casinoCoinsToFiatRate]: {
    fromUsdAmount: 1,
    toCoins: {
      GC: 10000,
      SWC: 1,
      DIA: 0
    }
  }
}
